export const STATUS = {
  pending: "Da approvare", awaiting_payment: "Attesa pagamento", confirmed: "Confermata", cancelled: "Annullata",
  rejected: "Rifiutata", expired: "Scaduta", completed: "Conclusa", no_show: "Non presentato",
};
export const TONE = {
  pending: "bg-amber-50 text-amber-700", awaiting_payment: "bg-orange-50 text-orange-700", confirmed: "bg-emerald-50 text-emerald-700",
  cancelled: "bg-slate-100 text-slate-500", rejected: "bg-red-50 text-red-700", expired: "bg-slate-100 text-slate-500",
  completed: "bg-sky-50 text-sky-700", no_show: "bg-red-50 text-red-700",
};
export const PAY = { not_required: "Gratuita", due: "Da pagare", paid_offline: "Pagata di persona", paid: "Pagata" };
export const PAY_MODE = { free: "Nessun pagamento online", deposit: "Acconto", full: "Pagamento intero" };
export const DAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];
export const ACTIONS = {
  pending: [["confirm", "Conferma"], ["reject", "Rifiuta"]],
  awaiting_payment: [["mark_paid", "Registra pagamento ricevuto"], ["cancel", "Annulla"]],
  confirmed: [["complete", "Segna conclusa"], ["no_show", "Non presentato"], ["cancel", "Annulla"]],
};
export const ACTION_DONE = { confirm: "Prenotazione confermata", reject: "Prenotazione rifiutata: orario liberato", cancel: "Prenotazione annullata: orario liberato",
  complete: "Segnata come conclusa", no_show: "Segnata come non presentato", mark_paid: "Pagamento registrato" };

export const money = (cents, cur = "EUR") => ((cents || 0) / 100).toLocaleString("it-IT", { style: "currency", currency: cur, useGrouping: "always" });
export const parseNum = (v) => {
  let s = String(v ?? "").replace(/[€\s]/g, "");
  if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
  else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, "");
  return /^-?\d+(\.\d+)?$/.test(s) ? parseFloat(s) : null;
};
// Italian or plain decimals («1.250,50», «1250.5», «€ 30»): cents, or null when not a number.
export const parseCents = (v) => { const n = parseNum(v); return n == null ? null : Math.round(n * 100); };
export const toCents = (v) => parseCents(v) ?? 0;
export const dayLabel = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
export const isoDay = (d) => d.toISOString().slice(0, 10);
